import "./css/Board.css";
import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FormCard } from "./../layout/FormCard";
import { Form } from "react-advanced-form";
import { RIEInput, RIETextArea } from "@attently/riek";
import SessionCard from "./../session/SessionCard";
import MainContainer from "./../layout/MainContainer";
import PrivacyToggle from "./../layout/PrivacyToggle";
import StarBar from "./../layout/StarBar";
import UserBoardRequests from "./../../requests/UserBoardRequests";
import ImageUploader from "react-images-upload";
import ImageGallery from "react-image-gallery";
import { boardPlaceholder } from "./../../lib/utils/placeholder";
import OwnerBadge from "./../layout/OwnerBadge";
import TypeAheadInput from "./../form/TypeAheadInput";
import { matchSuggestions } from "./../../lib/utils/suggest";
import BoardSelect from "./forms/BoardSelect";
import CommunityScore from "./CommunityScore";
import { isReadOnly } from "./../../lib/utils/demo";
import { sizes } from "./data/board_sizes";
import { loadBoards } from "./../../actions/board";
import { loadBoardRating } from "./../../actions/board_rating";
import { loadShapers } from "./../../actions/shaper";
import { loadUserSessions } from "./../../actions/user_session";
import {
	loadUserBoard,
	updateUserBoard,
	loadUserBoardImages,
	addUserBoardImages,
	deleteUserBoardImage,
} from "./../../actions/user_board";

const mapStateToProps = (state) => {
	return {
		session: state.session,
		board: state.user_boards.selected,
		boards: state.boards.data,
		shapers: state.shapers.data,
		images: state.user_board_images,
		boardRatings: state.board_ratings.byBoard,
	};
};

const mapDispachToProps = (dispatch) => {
	return {
		loadBoard: (session, params) =>
			dispatch(loadUserBoard(session, params)),
		loadSessions: (session, params) =>
			dispatch(loadUserSessions(session, params)),
		loadShapers: (session, params) =>
			dispatch(loadShapers(session, params)),
		loadBoards: (session, params) => dispatch(loadBoards(session, params)),
		loadRating: (session, id) => dispatch(loadBoardRating(session, id)),
		editUserBoard: (session, params) =>
			dispatch(updateUserBoard(session, params)),
		loadBoardImages: (session, params) =>
			dispatch(loadUserBoardImages(session, params)),
		addImages: (session, params) =>
			dispatch(addUserBoardImages(session, params)),
		deleteBoardImage: (session, id) =>
			dispatch(deleteUserBoardImage(session, id)),
	};
};

const relations = {
	user_session: ["Location", "SessionImage", "User"],
	selected_board: [
		"Board.Manufacturer",
		"Session.SessionImage",
		"Session.UserBoard",
		"User",
	],
	shapers: ["Board"],
	boards: ["Manufacturer"],
};

class BoardView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			session: [],
			board_id: "",
			manufacturer_id: "",
			uploaderInstance: 1,
			imageIndex: 0,
			modelPlaceholder: null,
			boardSizeOptions: this.prepBoardSizeOptions(sizes),
			isDisabled: true,
		};
		this.onDrop = this.onDrop.bind(this);
	}

	/*
	 * A board marked public opens from a shared link. The board, the sessions
	 * it was ridden in and its images all scope to owner-or-public server-side,
	 * so they load either way; the catalog lists behind the two type-aheads do
	 * not, because they only feed controls a non-owner cannot use.
	 */
	/*
	 * The community score keys on the catalog model, and board_id only exists
	 * once the board itself has loaded - so this cannot ride along in
	 * componentDidMount the way the other four requests do.
	 *
	 * requestedRating rather than a store check: a failed request never fills
	 * the store, and componentDidUpdate would re-fire it on every render.
	 */
	requestedRating = null;

	componentDidUpdate() {
		const board = this.props.board || {};
		if (!board.board_id) return;
		if (this.requestedRating === board.board_id) return;
		this.requestedRating = board.board_id;
		this.props.loadRating(this.props.session, board.board_id);
	}

	componentDidMount() {
		this.props.loadBoard(this.props.session, {
			id: this.props.match.params.id,
			withs: relations.selected_board,
		});
		this.props.loadSessions(this.props.session, {
			wheres: { board_id: this.props.match.params.id },
			withs: relations.user_session,
		});
		this.props.loadBoardImages(this.props.session, {
			wheres: { user_board_id: this.props.match.params.id },
		});
		if (this.props.session.isLoggedIn) {
			this.props.loadBoards(this.props.session, {
				limit: 1000,
				withs: relations.boards,
			});
			this.props.loadShapers(this.props.session, {
				withs: relations.shapers,
			});
		}
	}

	// BoardSelect keys on id and labels on name. A size is its own label, so
	// both carry the same string.
	prepBoardSizeOptions = (sizes) => sizes.map((size) => ({ id: size, name: size }));

	onTypeAheadSelected = (propertyName, newValue) => {
		const data = {};
		data[propertyName] = newValue;
		//here we have to make sure to clear out the model if not belong to shaper
		if (propertyName === "manufacturer_id") {
			const boardId = !Number.isInteger(this.state.board_id)
				? this.props.board.id
				: this.state.board_id;
			const board = this.props.boards.find(
				(board) => board.id === boardId
			);
			if (board && board.manufacturer_id !== newValue) {
				data["board_id"] = "";
				data["modelPlaceholder"] = "Choose A Board";
			}
		}
		this.setState({
			...data,
		});
		// This used to setState and stop, so both type-aheads reverted on
		// reload while every other field on the page persisted. Only board_id
		// is written: manufacturer_id is not a column on user_boards, the
		// shaper only narrows which models the model picker offers.
		if (data.board_id) {
			this.submitUpdate({ board_id: data.board_id });
		}
	};

	getShaperSuggestions = (value) =>
		matchSuggestions(this.props.shapers, "name", value);

	// The page opens with manufacturer_id empty because the shaper is not a
	// column on user_boards; it has to come off the catalog row the board
	// points at until the picker sets one.
	getBoardSuggestions = (value) => {
		const shaperId = Number(
			this.state.manufacturer_id === ""
				? this.props.board.Board.manufacturer_id
				: this.state.manufacturer_id
		);
		const boards = this.props.boards.filter(
			(entity) => Number(entity.manufacturer_id) === shaperId
		);
		return matchSuggestions(boards, "model", value);
	};

	/*
	Every edit on this page lands on user_boards through PUT /api/user_board/:id.
	The catalog row the board points at is reached through board.Board and is
	never in this payload: changing the shaper or the model repoints board_id,
	it does not rewrite the model everyone else sees.
	*/
	submitUpdate = (data) => {
		this.props.editUserBoard(this.props.session, {
			id: this.props.match.params.id,
			data: data,
		});
		this.setState(data);
	};

	// The API sends is_public back as a MySQL tinyint, so it arrives as 1/0 on
	// some paths and true/false on others. Strict === true misses the tinyint.
	isPublic = () => Number(this.props.board.is_public) === 1;

	// Compared against the stored record rather than local state, so a second
	// click is not swallowed by a guard reading a value the toggle never wrote.
	onPrivacyChange = (e) => {
		const next = parseInt(e.nextValue, 10) === 1;
		if (next === this.isPublic()) return;
		this.submitUpdate({ is_public: next ? 1 : 0 });
	};

	returnToIndex = (e) => {
		this.props.history.length > 1
			? this.props.history.goBack()
			: this.props.history.push("/board");
	};

	onDrop(pictureFiles, pictureDataURLs) {
		if (!pictureFiles.length) return;
		const formData = UserBoardRequests.createFormRequest({
			user_board_id: this.props.board.id,
			user_id: this.props.session.user.id,
		});
		pictureFiles.forEach((file, i) => {
			formData.append("photo", file);
		});
		this.props.addImages(this.props.session, { data: formData });
		this.setState({ uploaderInstance: this.state.uploaderInstance + 1 });
	}

	onImageLoad = (e) => {
		this.setState({ selectedImage: this.props.images[0] });
	};

	onImageSelected = (e) => {
		this.setState({ selectedImage: this.props.images[e], imageIndex: e });
	};

	deleteImage = (e) => {
		new Promise((resolve, reject) => {
			resolve(
				this.props.deleteBoardImage(
					this.props.session,
					this.state.selectedImage.id
				)
			);
		}).then((e) => {
			const newIndex =
				this.state.imageIndex === 0 ? 0 : this.state.imageIndex - 1;
			this.setState({
				imageIndex: newIndex,
				selectedImage: this.props.images[newIndex],
			});
		});
	};

	render() {
		const { board } = this.props;
		// DEFAULT_SESSION carries no user key, so reading .id off it threw on an
		// anonymous visit before componentDidMount could redirect.
		const viewer = this.props.session.user || {};
		// The demo signs in as the board's owner, so ownership alone would hand
		// every visitor the edit controls on a shared account.
		const isOwner = Boolean(viewer.id)
			&& this.props.board.user_id === viewer.id
			&& !isReadOnly(this.props.session);
		// The reducer cannot know which board it is holding images for, so the
		// stand-in it supplies is generic until here.
		const galleryItems = this.props.images.map((image) =>
			image.placeholder
				? Object.assign({}, image, {
						original: boardPlaceholder(board.id),
						thumbnail: boardPlaceholder(board.id),
				  })
				: image
		);
		const modelPlaceholder = this.state.modelPlaceholder
			? this.state.modelPlaceholder
			: board.Board
			? board.Board.model
			: "Choose A Model";
		return (
			<MainContainer>
				<FormCard returnToIndex={this.returnToIndex}>
					<Form>
						<div className="container">
							<div className="details row">
								<div className="col-6 session-title">
									<RIEInput
										required={false}
										value={board.name || ""}
										defaultValue={board.name}
										change={this.submitUpdate}
										propName="name"
										editProps={{ disabled: !isOwner }}
										className="gw-title-field"
									/>
									<OwnerBadge user={board.User} label="Ridden by" />
								</div>
								<div className="col-6">
									{isOwner && (
										<div className="privacy text-right">
											<PrivacyToggle
												value={this.isPublic() ? "1" : "0"}
												onChange={this.onPrivacyChange}
											/>
										</div>
									)}
								</div>
							</div>
							<div className="row">
								<div className="preview col-6">
									{isOwner && (
										<FontAwesomeIcon
											size="lg"
											alt="delete user"
											style={{
												marginLeft: ".5em",
												float: "left",
												cursor: "pointer",
												position: "absolute",
												top: "1em",
												zIndex: "999",
												color: "white",
												left: "1em",
											}}
											icon={faTrash}
											onClick={this.deleteImage}
											value={this.state.imageIndex}
										/>
									)}
									{isOwner && (
									<ImageUploader
										key={this.state.uploaderInstance}
										withIcon={false}
										buttonText="+"
										onChange={this.onDrop}
										imgExtension={[
											".jpg",
											".jpeg",
											".png",
										]}
										maxFileSize={5242880}
										withPreview={false}
										withLabel={false}
										buttonClassName="upload-btn"
										style={{
											marginLeft: ".5em",
											float: "left",
											cursor: "pointer",
											position: "absolute",
											top: "0",
											zIndex: "999",
											color: "white",
											left: "3em",
										}}
									/>
									)}
									<div>
										<ImageGallery
											items={galleryItems}
											showBullets={true}
											showIndex={true}
											startIndex={this.state.imageIndex}
											onSlide={this.onImageSelected}
											showNav={false}
											onImageLoad={this.onImageLoad}
										/>
									</div>
								</div>
								<div className="details col-md-6">
									<div className="detail-line">
										<StarBar
											stars={board.rating}
											onClick={this.submitUpdate}
											size="1x"
											static={!isOwner}
										/>
										<div className="gw-community-label">
											{isOwner ? "Your rating" : "Owner's rating"}
										</div>
									</div>
									{/* The model's score across every rider who
									    owns one, which is the number this
									    rider's own stars are worth comparing
									    against. Absent until board_id lands. */}
									<div className="detail-line gw-community-line">
										<CommunityScore
											rating={(this.props.boardRatings || {})[board.board_id]}
										/>
										{board.Board && board.Board.model && (
											<div className="gw-community-model">
												{board.Board.model}
											</div>
										)}
									</div>
									<div className="detail-line">
										<div>
											<strong>Size:</strong>
										</div>
										{/* riec rendered this as bare text that
										    swapped for the OS select on click,
										    and isDisabled={0} let anyone change
										    a board that was not theirs. */}
										<div className="board-size-select">
											<BoardSelect
												value={board.size}
												options={this.state.boardSizeOptions}
												onChange={(size) => this.submitUpdate({ size: size })}
												disabled={!isOwner}
												placeholder="None"
											/>
										</div>
									</div>
									<div className="detail-line">
										<div>
											<strong>Shaper/Company:</strong>
										</div>
										<TypeAheadInput
											entity={this.props.shapers}
											name="manufacturer_id"
											keyName="name"
											className="form-control"
											placeholder={
												board.Board &&
												board.Board.Manufacturer
													? board.Board.Manufacturer
															.name
													: "Choose A Shaper"
											}
											value={this.state.manufacturer_id}
											setValue={this.onTypeAheadSelected}
											getSuggestions={
												this.getShaperSuggestions
											}
											display={true}
											disabled={!isOwner}
										/>
									</div>
									<div className="detail-line">
										<div>
											<strong>Model:</strong>
										</div>
										<TypeAheadInput
											entity={this.props.boards}
											name="board_id"
											keyName="model"
											className="form-control"
											placeholder={modelPlaceholder}
											value={this.state.board_id}
											setValue={this.onTypeAheadSelected}
											getSuggestions={
												this.getBoardSuggestions
											}
											display={true}
											disabled={!isOwner}
										/>
									</div>
									<div className="detail-line">
										<div>
											<strong>Notes:</strong>
										</div>
										<RIETextArea
											value={
												board.notes ||
												"You have no notes for this board"
											}
											defaultValue={board.notes}
											className="form-control text-area"
											change={this.submitUpdate}
											propName="notes"
											validate={_.isString}
											editProps={{ disabled: !isOwner }}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="container">
							<div
								className="row col-12"
								style={{ marginTop: "1em" }}
							>
								<h5>Used In Sessions...</h5>
							</div>
							<div className="row col-12">
								{board.Sessions &&
									board.Sessions.reduce(
										(mappedArray, session, index) => {
											if (index < 3) {
												mappedArray.push(
													<div
														className="col-md-4"
														key={index}
													>
														<SessionCard
															session={session}
															key={session.id}
														/>
													</div>
												);
											}
											return mappedArray;
										},
										[]
									)}
								{(!board.Sessions ||
									board.Sessions.length === 0) && (
									<div className="col-12">
										<h3>No Sessions found at the moment</h3>
									</div>
								)}
							</div>
						</div>
					</Form>
				</FormCard>
			</MainContainer>
		);
	}
}
export default connect(mapStateToProps, mapDispachToProps)(BoardView);
